import React from 'react'
import { designTokens } from '@/utils/design-tokens'

interface RequiredLabelProps {
  children: React.ReactNode
  className?: string
}

const RequiredLabel: React.FC<RequiredLabelProps> = ({ children, className = '' }) => {
  return (
    <span className={className}>
      {children}
      <span
        className="ml-1"
        style={{
          fontFamily: designTokens.typography.fontFamily.sans[0],
          fontSize: designTokens.typography.fontSize['body-medium'][0],
          lineHeight: designTokens.typography.fontSize['body-medium'][1].lineHeight,
          color: '#dc2626',
          verticalAlign: 'top',
          fontWeight: 500
        }}
      >
        *
      </span>
    </span>
  )
}

export default RequiredLabel